export default __webpack_public_path__ + "static/media/faq.3ad13a40.svg";